import * as React from "react";
import { Route } from "react-router";
import { Auth } from "../../utils/auth";
import App from "../app";
import Landing from "../landing";
import CategoryOpportunitiesVw from "../opportunities";
import OpportunityVw from "../opportunity";
import ApplicationVw from "../apply";
import ProfileVw from "../profile";
import DemographicsVw from "../demographics";
import ResumeImportVw from "../resumeImport";
import NotificationsVw from "../notifications";
import AddExperienceVw from "../addExperience";
import SavedOpsVw from "../savedOps";
import HelpVw from "../help";
import GettingStartedVw from "../gettingStarted";
import DCIAFormVw from "../dciaApplication";
import HyApplicationVw from "../hyApplication";

const routeList: JSX.Element[] = [
  <Route key={100} path="/home" component={ Landing } />,
  <Route key={101} path="/categories/:catId/opportunities" component={CategoryOpportunitiesVw} />,
  <Route key={102} path="/opportunities/:opId" component={OpportunityVw} />,
  <Route key={103} path="/opportunities/:opId/apply" component={ApplicationVw} />,
  <Route key={200} path="/profile" component={ProfileVw} />,
  <Route key={201} path="/profile/about-me" component={DemographicsVw} />,
  <Route key={202} path="/profile/resume-import" component={ResumeImportVw} />,
  <Route key={203} path="/profile/add-experience(/:expType)" component={AddExperienceVw} />,
  <Route key={204} path="/profile/edit-experience/:id" component={AddExperienceVw} />,
  <Route key={205} path="/profile/saved-ops" component={SavedOpsVw} />,
  <Route key={300} path="/notifications" component={NotificationsVw} />,
  <Route key={400} path="/help" component={HelpVw} />,
  <Route key={500} path="/gettingStarted" component={GettingStartedVw} />,
  <Route key={600} path="/dcia" component={DCIAFormVw} />,
  <Route key={700} path="/hudsonYardsApplication" component={HyApplicationVw} />,
];
export default routeList;


// WEBPACK FOOTER //
// ./src/views/appBody/routes.tsx